var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopify(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "shopify-bg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "url(#shopify-bg)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52, 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.7,26.6 C118.6,25.8 117.9,25.4 117.3,25.3 C116.7,25.3 104.4,25.1 104.4,25.1 C104.4,25.1 95.7,16.6 94.8,15.7 C93.9,14.8 92.2,15.1 91.5,15.3 C91.4,15.3 89.8,15.8 87.2,16.6 C86.8,15.2 86.1,13.5 85.2,11.8 C82.3,6.3 78,3.3 72.9,3.3 C72.9,3.3 72.9,3.3 72.9,3.3 C72.5,3.3 72.2,3.3 71.8,3.4 C71.7,3.2 71.5,3.1 71.4,2.9 C69.2,0.6 66.4,-0.5 63,0.2 C56.5,1.6 50,9.8 47.9,19.9 C46.4,26.9 46.9,26.9 45.6,27.3 C43.4,28 41.3,28.6 38.5,29.5 C35.9,30.3 35.8,30.4 35.5,32.8 C35.3,34.6 28.2,89.3 28.2,89.3 L96.5,101.9 L136.8,92.9 C136.8,92.9 118.8,27.4 118.7,26.6 Z",
    fill: "#95BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.3,25.3 C116.7,25.3 104.4,25.1 104.4,25.1 C104.4,25.1 95.7,16.6 94.8,15.7 C94.5,15.4 94.1,15.2 93.6,15.1 L96.5,101.9 L136.8,92.9 C136.8,92.9 118.8,27.4 118.7,26.6 C118.6,25.8 117.9,25.4 117.3,25.3 Z",
    fill: "#5E8E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9,3.3 C72.5,3.3 72.2,3.3 71.8,3.4 C71.7,3.2 71.5,3.1 71.4,2.9 C69.2,0.6 66.4,-0.5 63,0.2 C56.5,1.6 50,9.8 47.9,19.9 C46.4,26.9 46.9,26.9 45.6,27.3 C43.4,28 41.3,28.6 38.5,29.5 L45.4,101.5 L96.5,101.9 L93.6,15.1 C89.5,7.9 82.9,3.4 72.9,3.3 Z",
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,20 C58.7,22.2 54,24.7 49.4,27.6 C50.9,20.9 56,12.6 61.4,9.2 C63,17.7 63,20 63,20 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 70,
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fontWeight: "bold",
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "S")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/shopify.48cc15e21f44e3ee017d7255a3933749.svg";
export { ForwardRef as ReactComponent };